// extracted by mini-css-extract-plugin
export default {"voidImgWrapper":"voidImgWrapper--fU3sw","voidImg":"voidImg--KNS32","voidText":"voidText--qFa9k"};